import React from 'react'
import { MenuItemType } from '@next-nx/utils/types'
import { ArrowRight } from '@next-nx/shared-ui/icons'
import { Button, WImage } from '@next-nx/shared-ui/atoms'
import styles from './TextImageBoxWithIcons.module.sass'


interface Props {
  item: MenuItemType | undefined
  imagePos: 'left' | 'right'
  imageLabel: ''
  imageLabelVariant: 'green' | 'blue' | 'purple'
  titleSize: 'md' | 'lg'
  bgVariant?: '' | 'white'
  ctaVariant: 'primary' | 'ghost'
  className?: string
  editMode?: boolean
  iconsBox?: any
}

const TextImageBoxWithIcons = (props: Props) => {

  const { 
    item = undefined,
    imagePos = 'left',
    imageLabel = '',
    imageLabelVariant = 'green',
    titleSize = 'md',
    bgVariant = '',
    ctaVariant = 'primary',
    className = '',
    editMode = false,
    iconsBox = undefined,
  } = props

  return item ? (
    <div className={`${styles.root} ${styles[`root--image-label-${imageLabelVariant}`]} ${bgVariant ? styles[`root--bg-${bgVariant}`] : ''} ${styles[`root--title-${titleSize}`]} ${styles[`root--image-${imagePos}`]} ${className}`}>
      <div className={styles.layout}>
        <div className={styles.imageBox}>
          <WImage 
            src={item.image}
            alt={item.name}
            title={item.name}
            maxWidth={767}
            maxHeight={400}
            layout="fill"
            objectFit="cover"
          />
          {!!imageLabel && <span className={styles.imageLabel}>{imageLabel}</span>}
        </div>
        <div className={styles.content}>
          {!!item.name && (
            editMode || (typeof item.name !== 'string')
            ? <div className={styles.title}>{item.name}</div>
            : <p className={styles.title}>{item.name}</p>
          )}
          {!!item.description && (
            editMode || (typeof item.description !== 'string')
            ? <div className={styles.description}>{item.description}</div>
            : <div className={styles.description} dangerouslySetInnerHTML={{ __html: item.description}} />
          )}
          {!!iconsBox && (
            editMode || (typeof iconsBox !== 'string')
            ? <div className={styles.iconsBox}>{iconsBox}</div>
            : <div className={styles.iconsBox} dangerouslySetInnerHTML={{ __html: iconsBox}} />
          )}
          {!!item.ctaLabel && !!item.url && (
            <div className={styles.ctaBox}>
              <Button label={item.ctaLabel} href={item.url} newPage={item.blank} variant={ctaVariant} icon={ctaVariant === 'ghost' ? <ArrowRight /> : null} iconPos="right" />
            </div>
          )}
        </div>
        
      </div>
    </div>
  ) : <></>
}

export default TextImageBoxWithIcons
